import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface YouchuanRemoveBackgroundParams {
  /**
   * 图像URL，必须是有效的HTTP/HTTPS URL，长度不超过1024字符
   */
  imgUrl: string;
  /**
   * 回调URL，必须是有效的HTTP/HTTPS URL
   */
  callback?: string;
}

export interface YouchuanRemoveBackgroundResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * youchuan_remove_background
 *
 * Youchuan Remove Background Image Generator
 *
 * Background removal implementation for Youchuan Open Platform (悠船开放平台).
 *
 * API Documentation: https://tob.youchuan.cn/openapi/apis/%E5%9B%BE%E7%89%87%E7%94%9F%E6%88%90/api_removebackground
 *
 * @example
 * ```typescript
 * import { initSeacloud, youchuanRemoveBackground } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await youchuanRemoveBackground({
 *   imgUrl: 'https://example.com/image.jpg'
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 YouchuanRemoveBackgroundParams 接口定义
 * @returns 生成的资源列表
 */
export async function youchuanRemoveBackground(
  params: YouchuanRemoveBackgroundParams,
): Promise<YouchuanRemoveBackgroundResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'youchuan_remove_background',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: YouchuanRemoveBackgroundResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
